module.exports = __webpack_public_path__ + "img/intuit-logo.92362c0b.svg";